var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHexagon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "89px",
    height: "101px",
    viewBox: "0 0 89 101",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 15") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AE",
    transform: "translate(-747.000000, -272.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card",
    transform: "translate(741.000000, 251.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(6.785901, 21.329629)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.5687736,73.0522027 L87.5687736,26.9477973 C87.5861583,25.5516107 86.8470753,24.2551188 85.6366537,23.5590372 L45.7054037,0.517626694 C44.509996,-0.172542231 43.0371931,-0.172542231 41.8417854,0.517626694 L1.9321199,23.5590372 C0.735201726,24.2474988 -0.00177997536,25.5238358 5.68434189e-14,26.9046284 L5.68434189e-14,73.0522027 C-0.0173846843,74.4483893 0.721698307,75.7448812 1.9321199,76.4409628 L41.8633699,99.4823733 C43.0587775,100.172542 44.5315805,100.172542 45.7269881,99.4823733 L85.6366537,76.4409628 C86.8470753,75.7448812 87.5861583,74.4483893 87.5687736,73.0522027 Z",
    id: "Path",
    fill: "#1B2C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8402513,68.2530514 L78.8402513,31.6992781 C78.8420933,30.4794535 78.1914,29.3519075 77.1346211,28.7437043 L45.4900131,10.4572836 C44.4345679,9.84757215 43.1342057,9.84757215 42.0787605,10.4572836 L10.4341525,28.7437043 C9.37737362,29.3519075 8.72668027,30.4794535 8.72852232,31.6992781 L8.72852232,68.2530514 C8.72668027,69.4728759 9.37737362,70.600422 10.4341525,71.2086251 L42.0787605,89.5427164 C43.1342057,90.1524279 44.4345679,90.1524279 45.4900131,89.5427164 L77.1346211,71.2086251 C78.1914,70.600422 78.8420933,69.4728759 78.8402513,68.2530514 Z",
    id: "Path",
    fill: "#071924"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagon);
export default __webpack_public_path__ + "static/media/hexagon.1aea381948462b21a68eb08e57ed6d71.svg";
export { ForwardRef as ReactComponent };